import React, { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import i18n from '../../i18n';
import { damageCodesState } from '../HomePage/ContentTabs/ContentTabsSlice';
import useStyles from './styles';

export default function DamageCodeAutocomplete(props) {
  const { validationError, damageList, isDisabledField } = props;
  const classes = useStyles();
  let lang = i18n.language;
  const [damageCodeList, setDamagesCodeList] = React.useState([]);

  const { englishDamageCodes } = useSelector(damageCodesState);
  const { germanDamageCodes } = useSelector(damageCodesState);
  const { frenchDamageCodes } = useSelector(damageCodesState);

  const [formattedList, setFormattedList] = React.useState([]);
  const [formattedDefaultList, setFormattedDefaultList] = React.useState([]);

  const [selectedDamageCodes, setSelectedDamageCodes] = React.useState([]);

  const [damageCodeErrorMessage, setDamageCodeErrorMessage] =
    React.useState(null);
  function formatList() {
    const list = [];

    damageCodeList.map((option) => {
      const formattedDamageCode = {
        code: 0,
        description: '',
      };
      formattedDamageCode.code = option.code;
      formattedDamageCode.description = `${option.code} (${option.description})`;
      list.push(formattedDamageCode);
      setFormattedList(list);
      return formattedList;
    });
  }
  function formatDefaultList() {
    const defaultList = [];

    damageList.map((option) => {
      const formattedDamageCode = {
        code: 0,
        description: '',
      };
      formattedDamageCode.code = option.code;
      if (
        formattedList.find((damage) => damage.code === option.code) !==
        undefined
      ) {
        formattedDamageCode.description = `${
          formattedList.find((damage) => damage.code === option.code)
            .description
        }`;
        defaultList.push(formattedDamageCode);

        setFormattedDefaultList(defaultList);
      }

      return formattedDefaultList;
    });
  }
  useEffect(() => {
    if (lang !== 'en' && lang !== 'fr' && lang !== 'de') {
      lang = 'en';
    }
  }, []);
  useEffect(() => {
    if (validationError && validationError.damageCode !== undefined) {
      setDamageCodeErrorMessage(validationError.damageCode);
    }
  }, [validationError]);
  useEffect(() => {
    setFormattedList([]);
    setFormattedDefaultList([]);
  }, [lang]);

  useEffect(() => {
    if (formattedList.length > 0) {
      formatDefaultList();
    }
  }, [formattedList, damageList]);
  useEffect(() => {
    if (damageCodeList !== undefined) {
      formatList();
    }
  }, [damageCodeList]);
  useEffect(() => {
    if (lang === 'en') {
      setDamagesCodeList(englishDamageCodes);
    } else if (lang === 'fr') {
      setDamagesCodeList(frenchDamageCodes);
    } else if (lang === 'de') {
      setDamagesCodeList(germanDamageCodes);
    } else {
      setDamagesCodeList(englishDamageCodes);
    }
  }, [lang, englishDamageCodes, frenchDamageCodes, germanDamageCodes]);
  async function onTagsChange(event, values) {
    setSelectedDamageCodes([]);

    setDamageCodeErrorMessage(null);
    values.map((option) => {
      const damageCode = damageCodeList.find(
        (damage) => damage.code === option.code,
      );
      selectedDamageCodes.push(damageCode);
      return selectedDamageCodes;
    });
    props.setDamageCodeList(selectedDamageCodes);
    if (selectedDamageCodes.length > 0) {
      props.resetValidationErrors();
    }
  }
  return (
    <div>
      {formattedDefaultList.length > 0 ||
      damageList.length === 0 ||
      (damageList.length === 1 &&
        damageList.find((damage) => damage.code === '0')) ? (
        <Autocomplete
          disabled={isDisabledField}
          defaultValue={formattedDefaultList ?? []}
          className={classes.autocomplete}
          size="small"
          multiple
          options={formattedList}
          getOptionLabel={(option) => option.description}
          ListboxProps={{ style: { maxHeight: '15rem' } }}
          renderOption={(option) => (
            <>
              <Typography className={classes.anomalyDetail}>
                {option.description}
              </Typography>
            </>
          )}
          renderInput={(params) => (
            <TextField
              disabled={isDisabledField}
              error={damageCodeErrorMessage !== null}
              helperText={damageCodeErrorMessage}
              {...params}
              variant="outlined"
            />
          )}
          getOptionSelected={(option, value) => option.code === value.code}
          onChange={onTagsChange}
        />
      ) : (
        <div />
      )}
    </div>
  );
}
